import React from "react";
import {Card, CardContent, CardHeader, Tab, Tabs, Typography, withStyles} from "material-ui";
import {BugReport, Code} from "@material-ui/icons";

import {Tasks} from "components";

import {bugs, server, website} from "variables/general";
// import {ecommIssues, s3Issues} from "../../views/Dashboard/Dashboard";

import tasksCardStyle from "assets/jss/material-dashboard-react/tasksCardStyle";
import {connect} from "react-redux";

class IssuesCardPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: 0
        };
    }

    handleChange = (event, value) => {
        this.setState({value});
    };

    render() {
        const {classes} = this.props;
        return (
            <Card className={classes.card}>
                <CardHeader
                    classes={{
                        root: classes.cardHeader,
                        title: classes.cardTitle,
                        content: classes.cardHeaderContent
                    }}
                    title="Issues:"
                    action={
                        <Tabs
                            classes={{
                                flexContainer: classes.tabsContainer,
                                indicator: classes.displayNone
                            }}
                            value={this.state.value}
                            onChange={this.handleChange}
                            textColor="inherit"
                        >
                            <Tab
                                classes={{
                                    wrapper: classes.tabWrapper,
                                    labelIcon: classes.labelIcon,
                                    label: classes.label,
                                    textColorInherit: classes.textColorInherit
                                }}
                                icon={<Code className={classes.tabIcon}/>}
                                label={"Ecomm"}
                            />
                            <Tab
                                classes={{
                                    wrapper: classes.tabWrapper,
                                    labelIcon: classes.labelIcon,
                                    label: classes.label,
                                    textColorInherit: classes.textColorInherit
                                }}
                                icon={<BugReport className={classes.tabIcon}/>}
                                label={"S3"}
                            />
                        </Tabs>
                    }
                />
                <CardContent>
                    {this.state.value === 0 && (
                        <Typography component="div">
                            <Tasks
                                checkedIndexes={[]}
                                tasksIndexes={this.getEcommIssueArray()}
                                tasks={this.getEcommIssues()}
                            />
                        </Typography>
                    )}
                    {this.state.value === 1 && (
                        <Typography component="div">
                            <Tasks
                                checkedIndexes={[]}
                                tasksIndexes={this.getS3IssueArray()}
                                tasks={this.getS3Issues()}
                            />
                        </Typography>
                    )}
                </CardContent>
            </Card>
        );
    }

    getEcommIssues() {
        if (this.props.reportData.ecommIssues) {
            return this.props.reportData.ecommIssues;
        } else {
            return [""];
        }
    }

    getEcommIssueArray() {
        if (this.props.reportData.ecommIssues) {
            var len = this.props.reportData.ecommIssues.length;

            var array = []
            for(var i=0; i < len; i++) {
                array.push(i);
            }
            return array;
        } else {
            return [];
        }
    }


    getS3Issues() {
        if (this.props.reportData.s3Issues) {
            return this.props.reportData.s3Issues;
        } else {
            return [""];
        }
    }

    getS3IssueArray() {
        if (this.props.reportData.s3Issues) {
            var len = this.props.reportData.s3Issues.length;

            var array = []
            for(var i=0; i < len; i++) {
                array.push(i);
            }
            return array;
        } else {
            return [];
        }
    }
}

// TasksCard.propTypes = {
//   classes: PropTypes.object.isRequired
// };

const mapStateToProps = state => {
    return {
        reportData: state.reportState.reportData
    }
};

const IssuesCard = connect(
    mapStateToProps
)(IssuesCardPage);


export default withStyles(tasksCardStyle)(IssuesCard);



// WEBPACK FOOTER //
// ./src/components/Cards/IssuesCard.jsx